




































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import elementResizeDetectorMaker from 'element-resize-detector';
import { ITab } from './types/Tab';
import Icon from '@/components/Icon.vue';

@Component({
  name: 'BaseTabs',
  components: {
    Icon,
  },
})
export default class BaseTabs extends Vue {
  @Prop() tabs: ITab[];

  @Watch('tabs')
  watchTabs() {
    this.displayedTabs = this.tabs;
  }

  hasSetEventListener = false;
  displayedTabs: ITab[] = [];
  scrollWidth = 0;
  tabsContainerWidth = 0;
  displayedTabsWidth = 0;
  currentScrollPosition = 0;
  elementResizeDetector = elementResizeDetectorMaker();

  get showArrows(): boolean {
    return this.scrollWidth > this.tabsContainerWidth;
  }

  get disableLeftArrow(): boolean {
    return this.currentScrollPosition === 0;
  }

  get disableRightArrow(): boolean {
    return this.scrollWidth <= this.displayedTabsWidth + this.currentScrollPosition;
  }

  get scrollStep(): number {
    return this.displayedTabsWidth / 3;
  }

  getArrowWidth(): number {
    return document.getElementById('right-tabs-arrow').clientWidth;
  }

  scrollLeft() {
    let scrollTo: number = this.currentScrollPosition - this.scrollStep;
    if (scrollTo < 0) {
      scrollTo = 0;
    }
    this.scroll(scrollTo);
  }

  scrollRight() {
    let scrollTo: number = this.currentScrollPosition + this.scrollStep;
    if (this.hasScrolledBeyondEnd(scrollTo)) {
      scrollTo = this.scrollWidth;
    }
    this.scroll(scrollTo);
  }

  hasScrolledBeyondEnd(scrollTo: number): boolean {
    return this.scrollWidth <= this.displayedTabsWidth + scrollTo;
  }

  scroll(scrollTo: number) {
    document
      .getElementById('displayed-tabs-container')
      .scrollTo({ left: scrollTo, top: 0, behavior: 'smooth' });
  }

  setCurrentScrollPosition() {
    this.currentScrollPosition = Math.round(
      document.getElementById('displayed-tabs-container').scrollLeft
    );
  }

  handleClick(key: string, index: number) {
    if (this.displayedTabs[index].isActive) {
      return;
    }
    this.setActiveTab(index);
    if (this.showArrows) {
      const scrollTo: number = this.getButtonPosition(key) - this.getArrowWidth();
      this.scroll(scrollTo);
    }
    this.$emit('select', key);
  }

  getButtonPosition(key: string): number {
    return document.getElementById(key).offsetLeft;
  }

  setActiveTab(index: number) {
    this.displayedTabs = this.displayedTabs.map((tab: ITab, currentIndex: number) =>
      currentIndex === index ? { ...tab, isActive: true } : { ...tab, isActive: false }
    );
  }

  setData() {
    this.scrollWidth = document.getElementById('displayed-tabs-container').scrollWidth;
    this.tabsContainerWidth = document.getElementById('tabs-container').clientWidth;
    this.displayedTabsWidth = document.getElementById('displayed-tabs-container').clientWidth;

    if (!this.hasSetEventListener) {
      document
        .getElementById('displayed-tabs-container')
        .addEventListener('scroll', this.setCurrentScrollPosition, { passive: true });
      this.hasSetEventListener = true;
    }
  }

  mounted() {
    this.displayedTabs = this.tabs;
    this.elementResizeDetector.listenTo(this.$refs.displayTabsContainer, () => this.setData());
  }
}
